// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Interesting_wrapper__3BqGp","title":"Interesting_title__1Ozpf","wrap":"Interesting_wrap__3kNS1","card":"Interesting_card__3dXQV","btns":"Interesting_btns__3XjcK"};